import WhatsTheDifference from "./WhatsTheDifference";
import HowToDeposit from "./HowToDeposit";
import IosAndAndroid from "./IosAndAndroid";
import TwoFaOffer from "./TwoFaOffer";
import ChangeEmail from "./ChangeEmail";

const QuestionList = [
  {
    question: "How do I get started with Data Mynt?",
    simpleAnswer:
      'Download app from Apple App store or Google Play Store and Sign Up. Contact us via Whatsapp         <a style="color: blue" href="TEL:+1-510-493-7072">+1-510-493-7072</a>  or  email <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@ddatamynt.zendesk.com</a> for questions or support.'
  },
  {
    question: "How can I fund my Data Mynt wallet?",
    simpleAnswer:
      'You can add funds to your account by depositing digital assets or mobile money or bank transfer in supported countries. To start this process, download app, reach out on DataMynt.com, contact us on Telegram or Whatsapp <a style="color: blue" href="TEL:+1-510-493-7072">+1-510-493-7072</a>,  (email <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a>).'
  },
  {
    question: "How do I send payments?",
    simpleAnswer:
      "Tap ‘Send Payment’ then input amount, receiver details including blockchain wallet, and confirm blockchain plus crypto to send. Please ensure that you are sending the right cryptocurrency to the right wallet address (e.g., send only Bitcoin to a Bitcoin address; do not send ETH to a Bitcoin address or it will be lost forever)."
  },
  {
    question: "Withdraw?",
    simpleAnswer:
      'Via Debit card from your DataMynt.com wallet or to initiate a Bank transfer email <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a>.'
  },
  {
    question: "How do I get paid?",
    simpleAnswer:
      "After downloading the Data Mynt app and Signing Up for an account, simply open the Data Mynt app and tap the Get Paid icon. Next, choose the amount of the transaction you want to be paid. Choose the cryptocurrency your customer will be paying in (e.g., Bitcoin), and add the customer’s email address if they want to receive a receipt. Your Data Mynt app will generate a QR code to receive the payment - this QR code is connected to your Data Mynt wallet, and can only receive the cryptocurrency that you and your customer have chosen (in this example, Bitcoin). Show this QR code to the customer and ask them to send the payment with their preferred cryptocurrency wallet. Once they have sent the payment, tap Continue and wait for the confirmation of the payment."
  },
  {
    question: "What is Data Mynt?",
    simpleAnswer:
      "Data Mynt is the leading provider of blockchain base operational and financial infrastructure for businesses, including multi currency wallets, payment processing, payment gateway, point of sale and other offerings. asset checkout and payment processing. What that means is that we allow our users to accept payments from their customers or send to suppliers in the form of cryptocurrency, with those payments being automatically converted into a localized stablecoin. This creates an easy-to-use pipeline between whatever cryptocurrency the customer wants to pay in and the bank account of the merchant, allowing more customers to pay for more goods and services in better, more efficient and cheaper ways."
  },
  {
    question:
      "What’s the difference between a Data Mynt Global Business Wallet and a Business Savings Account from a bank?",
    structuredAnswer: WhatsTheDifference
  },
  {
    question: "What is staking?",
    simpleAnswer:
      "Staking is the process of actively participating in transaction validation (similar to mining) on a proof-of-stake (PoS) blockchain. On these blockchains, anyone with a minimum-required balance of a specific cryptocurrency can validate transactions"
  },
  {
    question: "How does staking work?",
    simpleAnswer:
      "When the minimum balance is met, a node deposits that amount of cryptocurrency into the network as a stake (similar to a security deposit).<br/>The size of a stake is directly proportional to the chances of that node being chosen to forge the next block.<br/>If the node successfully creates a block, the validator receives a reward, similar to how a miner is rewarded in proof-of-work chains.<br/>Validators lose part of their stake if they double-sign or attempt to attack the network."
  },
  {
    question: "What is inflation?",
    simpleAnswer:
      "Assets such as Algorand (ALGO) earn rewards via inflation, or community rewards. With inflation, new tokens are added to the network at a rate determined by the protocol, and those tokens are then distributed to holders as rewards."
  },
  {
    question: "Who is the team behind Data Mynt?",
    simpleAnswer:
      ' See page here <a style="color: blue" href=" https://datamynt.com/aboutus">Here </a>'
  },
  {
    question:
      "How can I deposit funds into my Data Mynt Global Business Wallet?",
    structuredAnswer: HowToDeposit
  },
  {
    question:
      "What is the minimum balance required for a Data Mynt Business Wallet?",
    simpleAnswer:
      "There are no minimum balances required to have a Data Mynt Wallet"
  },
  {
    question:
      "If I have a problem with a deposit or withdrawal, what should I do?",
    simpleAnswer:
      'Contact us immediately at <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a> to resolve the issue.'
  },
  {
    question: "What are the deposit fees?",
    simpleAnswer: "<b>No deposit fees.</b>"
  },
  {
    question: "What are the withdrawal fees?",
    simpleAnswer: "<b>No withdrawal fees.</b>"
  },
  {
    question: "What States are not yet supported by Data Mynt?",
    simpleAnswer: "Hawaii, New York, Rhode Island."
  },
  {
    question:
      "How long do I have to leave the funds in my Data Mynt Business Wallet before I can withdraw them?",
    simpleAnswer:
      "You can withdraw your money whenever you want; you are always in control of your funds at Data Mynt."
  },
  {
    question: "Are Data Mynt Business Wallets covered by the FDIC?",
    simpleAnswer:
      "Data Mynt Wallets are not covered by the Federal Deposit Insurance Corporation."
  },
  {
    question: "How much does a Data Mynt account cost for me to use? ",
    simpleAnswer:
      "Data Mynt is charges 1% to accept payments and 0.5% to send. "
  },
  {
    question: "What Stablecoins are supported by Data Mynt?",
    simpleAnswer:
      "Data Mynt currently supports the following stablecoins: USDC, Tether, EURO Coin, and DAI."
  },
  {
    question: "Are there iOS and Android Apps available for Data Mynt?",
    simpleAnswer:
      "Absolutely! You can download the Data Mynt app from the Apple App Store, or the Google Play Store."
  },
  {
    question:
      "Does Data Mynt offer 2FA (Two-Factor Authentication) to secure my account?",
    structuredAnswer: TwoFaOffer
  },
  {
    question: "Can I change the email address for my account?",
    structuredAnswer: ChangeEmail
  },
  {
    question:
      "Does my customer need to have a Data Mynt account in order to pay me?",
    simpleAnswer:
      "Not at all! Your shopper can pay you using their preferred cryptocurrency wallet; you will need to simply enter the blockchain and cryptocurrency preferred and show them a unique QR code for them to scan with their wallet app and pay you."
  },
  {
    question: "What if I have Performance Issues in the app?",
    simpleAnswer:
      'If you find any performance issues in our platform and/or have any suggestions, please share them with us at <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a>.'
  },
  {
    question: "Are you Hiring?",
    simpleAnswer:
      'Yes! We’re actively looking for talented people who want to join us in building the future of financial services. Take a look at our open positions here: <a style="color: blue" href="https://angel.co/company/defi4all/jobs">https://angel.co/company/defi4all/jobs</a>.'
  }
];
export default QuestionList;
